const testimonials = [
  {
    id: 1,
    name: 'Alveena Rahman',
    title: 'Undergrad CSE Student',
    org: 'SUST',
    desc:
      'Palash is a talented web developer. He has good skill in both frontend and backend development.',
  },
  {
    id: 2,
    name: 'Jannatul Ferdousy Bushra',
    title: 'Undergrad CSE Student',
    org: 'City University',
    desc:
      'You have amazing communication skills. Also, his work is really amazing. Do really high-quality work.',
  },
  {
    id: 3,
    name: 'Shoptorshe Mrittika',
    title: 'MBBS Student',
    org: 'AKKMCH',
    desc:
      'You works are neat, clean and amazing. Deals with the requirements very smoothly. Best of Luck, Palash! ',
  },
];
export default testimonials;
